import React from "react";
import Footer from "../../main/footer";
import Nave from "../../main/header";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import Carousel from 'react-bootstrap/Carousel';
import { Textarea } from "react-bootstrap-icons";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import "./styles.css";
import Logo from '../../images/logo.png';
import Img3 from '../../images/img3.png';
import '../../styles/header.css';
import { SiGooglemaps } from "react-icons/si";
import { FaPhone } from "react-icons/fa6";
import Image2 from '../../images/store-bg-2.webp'
import AboutUs from '../../images/store-about-us.jpg'
import ProductQuote from "../../main/get_product_quote"; 


function Companypage() {

  const navigate = useNavigate();
  const [sheet, setSheet] = useState([
    {
      id: 1,
      name: "",
      quantity: "",
      piece: "",
      price: "",
      des: "",
      status: "normal",
    },
  ]);
  const [alert1, setAlert1] = useState(false)
  const [uid, setUid] = useState("")
  const pid = useRef('');
  const [user, setUser] = useState([]);
  const [allUID, setAllUID] = useState([]);
  const [profile, setProfile] = useState([]);
  const [companyCategory, setCompanyCategory] = useState([]);
  const [company, setCompany] = useState([]);
  const [director, setDirector] = useState([]);
  const [view, setView] = useState(1);
  const [cname, setCname] = useState("");
  const [imgCompany, setImgCompany] = useState([]);
  const [imgLogo, setImgLogo] = useState([]);
  const [aboutUsImage, setAboutUsImage] = useState([]);
  const [advertiseImage1, setAadvertiseImage1] = useState([]);
  const [advertiseImage2, setAadvertiseImage2] = useState([]);
  const [advertiseImage3, setAadvertiseImage3] = useState([]);


  
  const [mainBanner, setMainBanner] = useState([]);

  const { id, slug } = useParams();
  const location = useLocation();

  const [showImageModal, setShowImageModal] = useState(false);
const [currentImage, setCurrentImage] = useState("");

const handleImageClick = (imgUrl) => {
  setCurrentImage(imgUrl);
  setShowImageModal(true);
};


  const slugify = (text) => {
    return decodeURIComponent(decodeURIComponent(text))
      .replace(/\s+/g, "-")
      .replace(/%20/g, "-")
      .replace(/%2520/g, "-")
      .replace(/[^a-zA-Z0-9-]/g, "")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "")
      .trim()
      .toLowerCase();
  };  

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const legacyId = params.get("business");
    const legacySlug = params.get("cname");
  
    if (legacyId && legacySlug) {
      const formattedSlug = slugify(legacySlug);
      navigate(`/companydetail/${legacyId}/${formattedSlug}`, { replace: true });
      return;
    } else if (legacyId) {
      navigate(`/companydetail/${legacyId}`, { replace: true });
      return;
    }
  }, [location.search, navigate]);
  

  const insertEstoreView = async (store_user_id) => {
    if (!store_user_id) return;
    var viewer_id = 0;

    const aa = localStorage.getItem("USER");
    if (aa != null) {
      const as = JSON.parse(aa);
      viewer_id = as[0].id;
    }

    const ip = await fetch("https://api.ipify.org?format=json").then(res => res.json()).then(data => data.ip);
    const data = new FormData();
    data.append("store_user_id", store_user_id);
    data.append("viewer_id", viewer_id ?? 0);
    data.append("ip", ip);
  
    axios.post("/pro/analytics/insert_estore_view.php", data)
      .then(res => console.log("Estore view inserted"))
      .catch(err => console.log("Error", err));
  };
  

  useEffect(() => {
    const aa = localStorage.getItem("USER");
    if (aa != null) {
      const as = JSON.parse(aa);

      console.log("ttsss", as);

      setUid(as[0].id);

      setUser(as);
    } else {
    }
    get();

  }, []);

  const get = async () => {
    if (!id) {
      if (user.length > 0) {
        const userId = user[0].id;
        getProductbyuid(userId);
        CompanyProfileView(userId);
        ViewImgCompany(userId);
        insertEstoreView(userId);
        pid.current = userId;
        Director(userId);
      } else {
        navigate("/");
      }
    } else {
      getProductbyuid(id);
      CompanyProfileView(id);
      insertEstoreView(id);
      ViewImgCompany(id);
      Director(id);
      pid.current = id;
    }
  };
  

  const ViewImgCompany = async (uid) => {
    const data = new FormData();
    data.append('uid', uid);
    data.append('val', "view");
    axios({
      method: 'post',
      url: '/pro/profile/manage_profile_images.php',
      data: data,
      headers: {'Content-Type': 'multipart/form-data'},
    })
      .then(s => {
        setImgCompany(s.data)

        setImgLogo(s.data.find(item => item.type === "logo"));
        setMainBanner(s.data.find(item => item.type === "main banner"));
        setAboutUsImage(s.data.find(item => item.type === "about us"));

        setAadvertiseImage1(s.data.find(item => item.type === "advertise banner 1"));
        setAadvertiseImage2(s.data.find(item => item.type === "advertise banner 2"));
        setAadvertiseImage3(s.data.find(item => item.type === "advertise banner 3"));

        console.log("compny images",s.data)
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  const add_lead = async () => {

    const data = new FormData();

    data.append("uid", uid);
    data.append("sheet", JSON.stringify(sheet));
    data.append("cat", "cat");
    //data.append("img", "");

    axios({
      method: "post",
      url: "/pro/lead_add.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {

        setAlert1(!alert1);
        navigate('/product-buy-request')
      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });

  };
  const changeArayquote = (i, changes) => {
    const oldArr = [...sheet];
    const oldObj = oldArr[i];
    oldArr[i] = { ...oldObj, ...changes };
    setSheet(oldArr);
  };


  const getProductbyuid = async (id) => {
    const data = new FormData();

    data.append("uid", id);

    axios({
      method: "post",
      url: "/mainsite/productbyuid.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {

        setAllUID(s.data);

      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });
  };
  const CompanyProfileView = async (id) => {
    const data = new FormData();
    data.append("uid", id);
  
    axios({
      method: "post",
      url: "/pro/profile/profile_view_company.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        const dd = s.data[0]?.aray_pprofile || [];
        const d = s.data[0]?.aray_com || [];
        const categories = s.data[0]?.companyCategoriesData || [];
  
        setProfile(dd);
        setCompany(d);
        setCompanyCategory(categories);
  
        if (dd.length > 0 && dd[0].companyname) {
          setCname(dd[0].companyname);
        }
        else if (s.data[0]?.cname){
          setCname(s.data[0]?.cname);
        }
  
        const realSlug = slugify(s.data[0]?.cname || "");
        const currentSlug = slug || "";
  
        if (realSlug !== currentSlug) {
          navigate(`/companydetail/${id}/${realSlug}`, { replace: true });
          return;
        }
      })
      .catch((err) => {
        console.log("CompanyProfileView error =>>", err);
      });
  };
  


  const Director = async (uid) => {
    const data = new FormData();

    data.append("uid", uid);

    axios({
      method: "post",
      url: "/pro/profile/profile_view_director.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        setDirector(s.data)
        // console.log("Director List", s.data);
      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });
  };


  const generateAvatar = (name, size = 200) => {
    // Extract initials
    if(!name) {
      return "/assets/images/retail-store-icon.png"; 
    }

    const words = name.trim().split(/\s+/); // Split by spaces
    const initials = words.length > 1 
        ? words[0][0].toUpperCase() + words[1][0].toUpperCase() // First letter of first and second word
        : words[0][0].toUpperCase(); // Only first letter if one word

    // FNV-1a hashing for unique hash
    const generateColorFromName = (name) => {
        let hash = 2166136261; // FNV-1a 32-bit offset basis
        for (let i = 0; i < name.length; i++) {
            hash ^= name.charCodeAt(i);
            hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
        }
        // Convert hash to RGB values
        const r = (hash & 0xFF0000) >> 16; // Red
        const g = (hash & 0x00FF00) >> 8;  // Green
        const b = hash & 0x0000FF;         // Blue
        return `rgb(${r}, ${g}, ${b})`;    // Return as RGB string
    };

    const bgColor = generateColorFromName(name);

    // Create canvas
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = size;
    const ctx = canvas.getContext('2d');

    // Background color
    ctx.fillStyle = bgColor;
    ctx.fillRect(0, 0, size, size);

    // Text styling
    ctx.fillStyle = '#ffffff';
    ctx.font = `${size / 2}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(initials, size / 2, size / 2);

    // Return the image data URL
    return canvas.toDataURL('image/png');
};



  return (
<div>
  <Nave />

  <div className="">
  {view === 1 && (mainBanner?.image || imgLogo?.image || cname) ? (
    <section className="pt-5 bg-home9 no-gutters px-md-4">
      <div className="container">
        <div className="row equal-height d-flex justify-content-between">

          {/* Left - Carousel + Categories */}
          <div className="mb-4 col-lg-8 col-xl-9 d-flex flex-column align-items-stretch p-0" style={{ minHeight: '100%' }}>
            <div
              className="header-border-styles w-100 h-100"
              style={{
                boxShadow: "0px 0px 17px 6px #ccc",
                borderRadius: "16px",
                overflow: "hidden",
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
              }}>
              <div
                className="main-image"
                style={{
                  backgroundImage: `url(${mainBanner?.image || Image2})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  padding: "40px 20px",
                  position: "relative",
                  borderRadius: "16px 16px 0 0",
                  flex: 1
                }}>
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.5)",
                    borderRadius: "16px 16px 0 0",
                    zIndex: 1,
                  }}></div>

                <div
                  className="carousel slide"
                  data-bs-ride="carousel"
                  style={{ position: "relative", zIndex: 2 }}>
                  <div className="carousel-inner" style={{ minHeight: "130px" }}>
                    <div className="carousel-item active">
                      <div className="d-flex flex-column flex-md-row align-items-center gap-3 text-center text-md-start">
                        {(imgLogo?.image || cname) && (
                          <img
                            src={imgLogo?.image ? imgLogo.image : generateAvatar(cname)}
                            alt="Company Logo"
                            className="rounded bg-light shadow-sm"
                            style={{ maxHeight: '100%', height: 'auto', width: '100px', border: '2px solid #4f97a1' }}
                          />
                        )}
                        <div className="text-white d-flex flex-column justify-content-center" style={{ flex: 1 }}>
                        <h5
                          style={{
                            fontWeight: "bold",
                            fontSize: "clamp(1.5rem, 3vw, 2.2rem)",
                            margin: 0,
                            textTransform: "uppercase",
                          }}
                        >
                          {company[0]?.mainHeadings || cname || ''}
                        </h5>

                          <p className="text-white" style={{ fontSize: "clamp(1rem, 2vw, 1.25rem)", margin: 0 }}>
                            {company[0]?.mainParagraphs || ''}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Category Icons Grid */}
                <div className="row g-3 mt-4 justify-content-md-start justify-content-center text-center text-md-start" style={{ position: "relative", zIndex: 2 }}>
                {companyCategory.length > 0 && (
                  <>
                  {companyCategory.map((category, index) => (
                    <>
                    <div key={index} className="col-6 col-sm-4 col-md-3">
                      <div
                        className="d-flex flex-column align-items-center justify-content-center"
                        style={{
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                          borderRadius: "12px",
                          height: "100px",
                          transition: "all 0.3s ease-in-out",
                        }}>
                        <div style={{ fontSize: "32px", marginBottom: "4px", color: "#d1d5db" }}>
                          <i className={`fas ${category.icon}`} />
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            color: "#fff",
                            textAlign: "center",
                            lineHeight: "1.3",
                          }}>
                          {category.title}
                        </div>
                      </div>
                    </div>
                    </>
                      ))}
          

                          {/* View All */}
                          <div className="text-left mt-3" style={{ position: "relative", zIndex: 2 }}>
                          <div
                        className="p-2 d-flex flex-column"
                        style={{
                          borderRadius: "12px",
                         
                          transition: "all 0.3s ease-in-out",
                        }}> <span
                                className="fw-normal"
                                style={{ color: "#FD9636", fontSize: "18px" }}
                              >
                                This supplier deals in the above categories:
                              </span>
                              </div>
                          </div>


                      </>
                    )}
                </div>
              </div>
            </div>
          </div>

          {/* Right - Product Quote Form */}
          <div className="mb-4 col-lg-4 col-xl-3 d-flex align-items-stretch p-0">
            <div className="card card-estore-company w-100 d-flex flex-column h-100">
              <div className="d-flex justify-content-center align-items-center gap-5 h-100">
                <ProductQuote
                  product={[]}
                  user={user}
                  uid={uid}
                  piduser={pid.current}
                  navigate={navigate}
                  type={'business'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  ) : null}
{/* 🔹 About Us Section */}
{(company[0]?.description || profile[0]?.address || profile[0]?.companyphone) && (
  <section className="bg-home9 no-gutters px-md-4">
    <div className="container">
      <div className="row">
        <div className="col-12 mb-4 d-flex flex-column align-items-stretch p-0">
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: "16px 16px 0 0",
              boxShadow: '0px 0px 6px 2px #ccc',
              overflow: 'hidden',
              marginLeft: '5px',
              marginRight: '5px'
            }}
          >
            {/* Heading */}
            <div className="d-flex justify-content-between align-items-center px-4" style={{ backgroundColor: '#D6EFF2' }}>
              <div className="d-flex align-items-center">
                <div style={{ fontSize: "50px", marginBottom: "4px", marginRight: "10px", color: "#4f97a1" }}>
                  <i className="fas fa-info-circle" />
                </div>
                <h4 className="mb-0 text-dark">About Us</h4>
              </div>
            </div>

            {/* Content */}
            <div className="row p-4">
              <div className="col-md-7 col-12 mb-4 text-dark">
                <div className="d-flex flex-column gap-4">
                  {company[0]?.description && (
                    <div>
                      <h6 className="fw-bold mb-2"><i className="fas fa-user me-2 text-info"></i>Description</h6>
                      <p className="mb-0">{company[0].description}</p>
                    </div>
                  )}

                  {profile[0]?.address && (
                    <div>
                      <h6 className="fw-bold mb-2"><i className="fas fa-store me-2 text-info"></i>Address</h6>
                      <p className="mb-0">{profile[0].address}</p>
                    </div>
                  )}

                  {/* {profile[0]?.companyphone && (
                    <div>
                      <h6 className="fw-bold mb-2"><i className="fas fa-phone me-2 text-info"></i>Phone Number</h6>
                      <p className="mb-0">{profile[0].companyphone}</p>
                    </div>
                  )} */}
                </div>
              </div>

              <div className="col-md-5 d-none d-md-block">
                <img
                  src={aboutUsImage?.image || AboutUs}
                  alt="About Us"
                  className="img-fluid"
                  style={{ borderRadius: '10px', width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)}

{/* 🔹 Advertise Section Styled Like About Us/Products */}
{[advertiseImage1, advertiseImage2, advertiseImage3].some(img => img?.image) && (
  <section className="bg-home9 no-gutters px-md-4">
    <div className="container">
      <div className="row">
        <div className="col-12 mb-4 d-flex flex-column align-items-stretch p-0">
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: "16px 16px 0 0",
              boxShadow: '0px 0px 6px 2px #ccc',
              overflow: 'hidden',
              marginLeft: '5px',
              marginRight: '5px'
            }}
          >
            {/* Heading */}
            <div className="d-flex justify-content-between align-items-center px-4" style={{ backgroundColor: '#D6EFF2' }}>
              <div className="d-flex align-items-center">
                <div style={{ fontSize: "50px", marginBottom: "4px", marginRight: "10px", color: "#4f97a1" }}>
                  <i className="fas fa-image" />
                </div>
                <h4 className="mb-0 text-dark">Advertisements</h4>
              </div>
            </div>

            {/* Image Grid */}
            <div className="row p-4 gx-3 gy-3">
              {(() => {
                const images = [advertiseImage1, advertiseImage2, advertiseImage3].filter(img => img?.image);
                const count = images.length;

                if (count === 1) {
                  return (
                    <div className="col-12">
                      <img
                        src={images[0].image}
                        alt="Advertisement"
                        onClick={() => handleImageClick(images[0].image)}
                        className="img-fluid w-100"
                        style={{ border: "1px solid #4f97a1", borderRadius: "16px", height: '300px', objectFit: 'cover', cursor: 'pointer' }}
                      />
                    </div>
                  );
                }

                if (count === 2) {
                  return images.map((img, i) => (
                    <div className="col-md-6" key={i}>
                      <img
                        src={img.image}
                        alt={`Ad ${i + 1}`}
                        onClick={() => handleImageClick(img.image)}
                        className="img-fluid w-100"
                        style={{ border: "1px solid #4f97a1", borderRadius: "16px", height: '250px', objectFit: 'cover', cursor: 'pointer' }}
                      />
                    </div>
                  ));
                }

                if (count === 3) {
                  return (
                    <>
                      <div className="col-md-6">
                        <img
                          src={images[0].image}
                          alt="Ad 1"
                          onClick={() => handleImageClick(images[0].image)}
                          className="img-fluid w-100"
                          style={{ border: "1px solid #4f97a1", borderRadius: "16px", height: '300px', objectFit: 'cover', cursor: 'pointer' }}
                        />
                      </div>
                      <div className="col-md-6 d-flex flex-column gap-3">
                        {[images[1], images[2]].map((img, i) => (
                          <div className="flex-grow-1" key={i}>
                            <img
                              src={img.image}
                              alt={`Ad ${i + 2}`}
                              onClick={() => handleImageClick(img.image)}
                              className="img-fluid w-100"
                              style={{ border: "1px solid #4f97a1", borderRadius: "16px", height: '145px', objectFit: 'cover', cursor: 'pointer' }}
                            />
                          </div>
                        ))}
                      </div>
                    </>
                  );
                }

                return null;
              })()}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)}



{/* 🔹 Products Section */}
{allUID.length > 0 && (
  <section className="bg-home9 no-gutters px-md-4">
    <div className="container">
      <div className="row">
        <div className="col-12 mb-4 d-flex flex-column align-items-stretch p-0">
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: "16px 16px 0 0",
              boxShadow: '0px 0px 6px 2px #ccc',
              overflow: 'hidden',
              marginLeft: '5px',
              marginRight: '5px'
            }}
          >
            {/* Heading */}
            <div className="d-flex justify-content-between align-items-center px-4" style={{ backgroundColor: '#D6EFF2' }}>
              <div className="d-flex align-items-center">
                <div style={{ fontSize: "50px", marginBottom: "4px", marginRight: "10px", color: "#4f97a1" }}>
                  <i className="fas fa-box" />
                </div>
                <h4 className="mb-0 text-dark">Products</h4>
              </div>
            </div>

            {/* Products Grid */}
            <div className="row p-4">
              {allUID.map((item, index) => (
                <div className="col-md-3 col-sm-6 mb-4" key={index}>
                  <div className="card h-100 d-flex flex-column" style={{ borderRadius: '16px' }}>
                    <a href={`/product?id=${item.id}&s=${item.name}`} className="text-decoration-none">
                      <div className="d-flex justify-content-center align-items-center"
                        style={{
                          height: '200px',
                          overflow: 'hidden',
                          borderTopLeftRadius: '16px',
                          borderTopRightRadius: '16px'
                        }}>
                        <img
                          src={item.img}
                          alt={item.name}
                          className="img-fluid"
                          style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                        />
                      </div>
                    </a>
                    <div className="card-body text-center flex-grow-1 d-flex flex-column">
                      <h5 className="card-title">{item.name}</h5>
                      <div className="mt-auto">
                        <a href={`/product?id=${item.id}&s=${item.name}`}>
                          <p className="my-2" style={{
                            fontSize: "16px",
                            fontWeight: 700,
                            color: item.price !== 0 ? "#036770" : "red",
                          }}>
                            {item.price !== 0
                              ? new Intl.NumberFormat("en-PK", {
                                style: "currency",
                                currency: "PKR",
                                minimumFractionDigits: 2,
                              }).format(item.price)
                              : window.zero_price}
                          </p>
                          <button className="btn btn-sm w-100" style={{
                            maxHeight: "50px",
                            borderRadius: "5px",
                            backgroundColor: "#45ACB3",
                            color: "white",
                            border: "none",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                            fontSize: "13px",
                          }}>
                            Get Quote
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)}

</div>

{/* 🔹 Fullscreen Image Modal */}
{showImageModal && (
  <div
    className="modal show fade"
    tabIndex="-1"
    style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
    onClick={() => setShowImageModal(false)}
  >
    <div className="modal-dialog modal-dialog-centered modal-xl" onClick={e => e.stopPropagation()}>
      <div className="modal-content bg-transparent border-0">
        <div className="modal-body text-center p-0">
          <img src={currentImage} alt="Full View" className="img-fluid rounded" />
        </div>
      </div>
    </div>
  </div>
)}





  <Footer />
</div>

  );
}

export default Companypage;
